import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ButtonLink } from '../ui/Button';
import { IMG } from '../../data/images';
import { spring, viewportOnce } from '../../utils/motion';
export function ChefRecruit() {
  const reduce = useReducedMotion();
  return <section aria-labelledby="recruit-heading" className="border-t border-hairline bg-oat" data-id="element-490" data-mp="1e6fqf4blest6">
      <div className="mx-auto grid max-w-shell items-center gap-10 px-5 py-16 lg:grid-cols-[1fr_0.85fr] lg:px-8 lg:py-20" data-id="element-491" data-mp="1rxkgpft2m8qu">
        <div data-id="element-492" data-mp="1mz98tamc68b9">
          <p className="text-[13px] font-semibold uppercase tracking-[0.06em] text-action" data-id="element-493" data-mp="1mxg2jwfmxq3s">For chefs</p>
          <h2 id="recruit-heading" className="mt-4 max-w-[24ch] font-display text-[clamp(1.9rem,3.4vw,3rem)] font-semibold leading-[1.05] tracking-[-0.02em] text-ink" data-id="element-494" data-mp="21ufge212yf6p">
            Price your menus properly. Stop guessing at hourly.
          </h2>
          <p className="mt-4 max-w-[52ch] text-lg leading-relaxed text-ink-2" data-id="element-495" data-mp="2imeps3cklnn">
            Publish set menus with a price per guest, a minimum head count, and honest grocery terms. Quote from the menu in
            two taps, get a deposit before you shop, and keep 90% of the line total.
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3" data-id="element-496" data-mp="2w652z9gfni9p">
            <ButtonLink to="/for-chefs" variant="action" size="lg" data-id="element-497" data-mp="2w4tz79mzmail">
              See what you would earn
            </ButtonLink>
            <ButtonLink to="/chef/onboarding" variant="outline" size="lg" data-id="element-498" data-mp="35vybg1la3h9q">
              Build a listing
            </ButtonLink>
          </div>
        </div>
        <motion.div initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 24,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={viewportOnce} transition={reduce ? {
        duration: 0.15
      } : spring.heavy} className="overflow-hidden rounded-2xl border border-hairline" data-id="element-499" data-mp="3athqh3psvy2q">
          <img src={IMG.cooking} alt="A private chef searing scallops in a copper pan on a home hob" className="aspect-[3/2] w-full object-cover" loading="lazy" data-id="element-500" data-mp="1phq3pd563ci5" />
        </motion.div>
      </div>
    </section>;
}